// Export all node components
export { default as StartNode } from './StartNode';
export { default as EndNode } from './EndNode';
export { default as ATCommandNode } from './ATCommandNode';
export { default as ConditionNode } from './ConditionNode';
export { default as LoopNode } from './LoopNode';
export { default as ParallelNode } from './ParallelNode';
export { default as DelayNode } from './DelayNode';
export { default as VariableNode } from './VariableNode';
export { default as AssertionNode } from './AssertionNode';
export { default as LogNode } from './LogNode';
export { default as PrimitiveCallNode } from './PrimitiveCallNode';
export { default as TransformNode } from './TransformNode';
export { default as DataTestNode } from './DataTestNode';
export { default as VoiceTestNode } from './VoiceTestNode';
export { default as VoiceAgentTestNode } from './VoiceAgentTestNode';

// Node types map for ReactFlow
import { NodeTypes } from 'reactflow';
import StartNode from './StartNode';
import EndNode from './EndNode';
import ATCommandNode from './ATCommandNode';
import ConditionNode from './ConditionNode';
import LoopNode from './LoopNode';
import ParallelNode from './ParallelNode';
import DelayNode from './DelayNode';
import VariableNode from './VariableNode';
import AssertionNode from './AssertionNode';
import LogNode from './LogNode';
import PrimitiveCallNode from './PrimitiveCallNode';
import TransformNode from './TransformNode';
import DataTestNode from './DataTestNode';
import VoiceTestNode from './VoiceTestNode';
import VoiceAgentTestNode from './VoiceAgentTestNode';

export const nodeTypes: NodeTypes = {
  start: StartNode,
  end: EndNode,
  atCommand: ATCommandNode,
  condition: ConditionNode,
  loop: LoopNode,
  parallel: ParallelNode,
  delay: DelayNode,
  variable: VariableNode,
  assertion: AssertionNode,
  log: LogNode,
  primitiveCall: PrimitiveCallNode,
  transform: TransformNode,
  dataTest: DataTestNode,
  voiceTest: VoiceTestNode,
  voiceAgentTest: VoiceAgentTestNode,
};

